import type { ConfigurationReportsOptions } from '@placer-ui/types';

export interface ConfigurationReportDateOptionState extends ConfigurationReportsOptions {}

export const createConfigurationReportDateOptionsState =
    (): ConfigurationReportDateOptionState => ({
        entities_data: undefined,
    });
